export default {
    actions: {
        catch({ commit }, payload) {
            commit("CATCH_ERROR", payload);
        },
    },
    getters: {
        readErrors(state) {
            return state.data;
        },
    },
    mutations: {
        CATCH_ERROR(state, errors) {
            state.data = errors;
        },
    },
    namespaced: true,
    state: {
        data: {},
    },
};
